<template>
  <div class="px-5 py-16 flex flex-col justify-center">
    <!-- ANIMATED ICON -->
    <div class="flex justify-center mt-4 mb-16">
      <!-- REPORT PAGES -->
      <section
        class="report-icon relative transition-transform duration-300 inline-block transform hover:rotate-6"
        @mouseover="handleMouseEnter"
        @mouseleave="handleMouseOut"
      >
        <div class="report-page absolute top-6 left-6" />
        <div class="report-page absolute top-3 left-3" />
        <div class="report-page relative z-5 flex flex-col justify-evenly px-3 py-1">
          <!-- GRAPH -->
          <section class="flex justify-between transform rotate-180">
            <div v-for="(n, index) in 5" :key="index" class="graph-bar" />
          </section>
          <!-- TABLE -->
          <table class="w-full h-1/3">
            <tbody>
              <tr v-for="(n, index) in 4" :key="index">
                <td v-for="(m, idx) in 3" :key="idx" />
              </tr>  
            </tbody>
          </table>
        </div>
        <!-- LOOP -->
        <Transition :name="'loop'">
          <div v-if="hoveredOver" class="absolute left-12 top-10 loop-container">
            <div class="border-8 border-gray-700 rounded-full relative w-14 h-14 bg-secondary bg-opacity-20 loop">
              <div class="absolute bg-gray-700 h-2 w-16 top-0 left-0 loop-handle" />
            </div>
          </div>
        </Transition>
      </section>
    </div>
    <h2>
      To browse your reports, please choose an option from the sidebar.
    </h2>
  </div>
</template>

<script>
export default {
  name: "ReportsDashboard",
  data() {
    return {
      hoveredOver: false,
      mouseLeft: true
    }
  },
  methods: {
    handleMouseEnter() {
      this.mouseLeft = false
      setTimeout(() => {
        if (!this.mouseLeft) this.hoveredOver = true
      }, 100)
    },
    handleMouseOut() {
      this.mouseLeft = true
      this.hoveredOver = false
    }
  }
}
</script>

<style scoped>
.report-page {
  height: 12rem;
  width: 8rem;
  border: 0.3rem solid var(--primary);
  background-color: #fff;
}
[data-theme="dark"] .report-page {
  background-color: #04141d;
}
.graph-bar {
  width: 0.7rem;
  background-color: #00bcf5;
  animation: bar-rise 5s infinite linear alternate;
  transform-origin: top left;
}
.graph-bar:nth-of-type(1) {
  height: 2rem;
}
.graph-bar:nth-of-type(2) {
  height: 3rem;
  animation-delay: -2s;
  animation-direction: alternate-reverse;
}
.graph-bar:nth-of-type(3) {
  height: 3.5rem;
  animation-delay: -3s;
}
.graph-bar:nth-of-type(4) {
  height: 1.5rem;
  animation-delay: -2.5s;
  animation-direction: alternate-reverse;
}
.graph-bar:nth-of-type(5) {
  height: 2.5rem;
  animation-delay: -1s;
}
table, th, td {
  border: 0.22rem solid var(--primary);
  border-collapse: collapse;
}
@keyframes bar-rise {
  0% { 
    transform: scaleY(1); 
  }
  100% { 
    transform: scaleY(0.5); 
  }
}
.loop {
  backdrop-filter: blur(1px);
}
.loop-handle {
  transform: rotate(45deg) translate(90%, 250%);
}
.loop-container {
  z-index: -1;
  transition: all 0.5s;
}
.report-icon:hover .loop-container {
  z-index: 6;
}
.loop-enter-active {
  animation: loop-in 0.5s;
}
.loop-leave-active {
  animation: loop-in 0.5s reverse;
}
@keyframes loop-in {
  0% { 
    transform: translate(0, 200%) scale(30%);
    z-index: -1;
  }
  50% {
    transform: translate(150%, 0);
    z-index: 6;
  }
  100% {
    transform: translate(0, 0);
    scale: (100%);
    z-index: 6;
  }
}


[data-theme="dark"] table,
[data-theme="dark"] th,
[data-theme="dark"] td {
  border-color: rgb(107, 114, 128);

}
/* Magnifying glass */
[data-theme="dark"] .loop {
  background-color: rgba(255, 255, 255, 0.04);
  border-color: #e6f0ff;
  backdrop-filter: blur(3px);
}

[data-theme="dark"] .loop-handle {
  background-color: #e6f0ff;

}

/* Optional: soften graph bars slightly in dark mode */

[data-theme="dark"] .graph-bar {
  background-color: #38d3ff;
}
</style>